export default __webpack_public_path__ + "static/media/p7-6.86fde3d6.png";